import { render, staticRenderFns } from "./TheErrorAlert.vue?vue&type=template&id=327d80be&scoped=true"
import script from "./TheErrorAlert.vue?vue&type=script&lang=js"
export * from "./TheErrorAlert.vue?vue&type=script&lang=js"
import style0 from "./TheErrorAlert.vue?vue&type=style&index=0&id=327d80be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327d80be",
  null
  
)

export default component.exports